import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import CmsElement from 'Components/Utilities/CmsElement';
import { RenderWYSIWYG } from "Components/Form";
import { Loading } from "Components/Partials";

import { getRecordValue } from "Services/CmsHelpers";
import { asset } from "Services/BaseHelpers";

export default class Leaderboard extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'leaderboard';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var allowUpdate
     * @type {boolean}
     */
    allowUpdate = false;

    /**
     * @var state
     */
    state = {
        working: true,
    };

    render() {
        const { working, records } = this.state;
        const content = {};
        //let carousel = [];
        let leaderboard_img_1 = [];
        let leaderboard_img_2 = [];
        let leaderboard_img_3 = [];
        let leaderboard_img_4 = [];

        if (records) {
            records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'content')
                .forEach(item => {
                    content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
                });

            // carousel = records.data
            //     .filter(item => getRecordValue(item, 'type').toLowerCase() === 'leaderboard')
            //     .map(item => getRecordValue(item, 'image', 'file'));
            leaderboard_img_1 = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'leaderboard')
                .map(item => getRecordValue(item, 'leaderboard_img_1', 'file'));
            leaderboard_img_2 = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'leaderboard')
                .map(item => getRecordValue(item, 'leaderboard_img_2', 'file'));
            leaderboard_img_3 = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'leaderboard')
                .map(item => getRecordValue(item, 'leaderboard_img_3', 'file'));
            leaderboard_img_4 = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'leaderboard')
                .map(item => getRecordValue(item, 'leaderboard_img_4', 'file'));
        }

        return (
            <Authenticated>
                <PageHeader
                    imgSrc="headers/leaderboard.jpg"
                />

                { working && <Loading/> }

                { !working && (
                    <>
                        <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                            <div className="flex justify-center pb-4">
                                <img
                                    src={ asset('images/mini-logo.png') }
                                    alt="Logo"
                                    className="block w-20 align-self-center"
                                />
                            </div>
                        </div>

                        <div className="bg-black p-4 md:p-8 text-white py-10 px-5 md:px-10 mb-10 ">
                            <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                                <RenderWYSIWYG
                                    className="text-white"
                                    content={ content['Welcome Text'] ?? '' }
                                />
                            </div>
                        </div>

                        {/*<div className="text-center flex items-center justify-center pb-10">*/}
                        {/*    { carousel?.map(leaderboard => (*/}
                        {/*        <img src={leaderboard} />*/}
                        {/*    )) }*/}
                        {/*</div>*/}
                        <div className="text-center flex items-center justify-center pb-10">
                            { leaderboard_img_1?.map(leaderboard_img_1 => (
                                <img src={leaderboard_img_1} />
                            )) }
                        </div>
                         <div className="text-center flex items-center justify-center pb-10">
                            { leaderboard_img_2?.map(leaderboard_img_2 => (
                                <img src={leaderboard_img_2} />
                            )) }
                        </div>
                         <div className="text-center flex items-center justify-center pb-10">
                            { leaderboard_img_3?.map(leaderboard_img_3 => (
                                <img src={leaderboard_img_3} />
                            )) }
                        </div>
                         <div className="text-center flex items-center justify-center pb-10">
                            { leaderboard_img_4?.map(leaderboard_img_4 => (
                                <img src={leaderboard_img_4} />
                            )) }
                        </div>
                    </>
                ) }
            </Authenticated>
        );
    }
}
